export const BUSINESS_INFO = {
  name: 'Lisa Merkle Design',
  phone: '(323) 745-2205',
  phoneHref: 'tel:+13237452205',
  email: 'lisa@lisamerkledesign.com',
  address: '215 N La Peer Dr',
  city: 'Beverly Hills, CA 90211',
  fullAddress: '215 N La Peer Dr, Beverly Hills, CA 90211, United States',
  logoUrl: 'https://lisamerkledesign.com/wp-content/uploads/2022/11/lisa-new-logo1.png',
  facebook: 'https://www.facebook.com/lisamerkledesign/',
  instagram: 'https://www.instagram.com/lisamerkledesign/',
  mapEmbed: 'https://maps.google.com/maps?cid=189405287750833219&output=embed',
  tagline: 'Expert-led design and remodels that elevate and protect long-term value.',
  tagline2: 'Executed with precision, discretion, and an uncompromising standard of craft.',
  publications: ['Elle Décor', 'Architectural Digest'],
};

export const SERVICES = [
  { title: 'Full House Design', icon: 'ri-home-4-line', description: 'Comprehensive top-to-bottom transformation that delivers a cohesive, timeless home.' },
  { title: 'Renovation Consultation', icon: 'ri-tools-line', description: 'Expert guidance to navigate complex renovations without costly mistakes.' },
  { title: 'Bedroom Design', icon: 'ri-hotel-bed-line', description: 'Serene, beautifully crafted bedroom sanctuaries tailored to your personal lifestyle.' },
  { title: 'Kitchen Design', icon: 'ri-restaurant-2-line', description: 'Functional luxury kitchens with timeless materials, refined layouts, and creative vision.' },
  { title: 'Bathroom Design', icon: 'ri-drop-line', description: 'Spa-inspired bathroom retreats combining practicality with architectural beauty.' },
  { title: 'Living Room Design', icon: 'ri-sofa-line', description: 'Elegant living spaces that balance comfort, sophistication, and personal style.' },
  { title: 'Dining Room Design', icon: 'ri-goblet-line', description: 'Exquisitely designed dining rooms that create lasting impressions for every occasion.' },
  { title: 'Home Office Design', icon: 'ri-computer-line', description: 'Inspiring workspaces that blend productivity with refined, luxurious design.' },
  { title: "Kids' Bedroom Design", icon: 'ri-bear-smile-line', description: 'Creative, beautiful spaces where children thrive and imagination flourishes.' },
  { title: 'Nursery Design', icon: 'ri-seedling-line', description: 'Tender, serene nurseries crafted with care, beauty, and safety in mind.' },
  { title: 'Lighting Selection', icon: 'ri-lightbulb-line', description: 'Curated lighting that enhances atmosphere, architecture, and your home\'s best features.' },
  { title: 'Flooring Selection', icon: 'ri-layout-grid-line', description: 'Expert flooring consultation with premium materials that elevate every room.' },
  { title: 'Color / Paint Selection', icon: 'ri-palette-line', description: 'Sophisticated color palettes rooted in design psychology and architectural harmony.' },
  { title: 'Art Selection & Procurement', icon: 'ri-gallery-line', description: 'Curated art collections sourced and procured to perfectly complement your interiors.' },
  { title: 'Window Treatments', icon: 'ri-article-line', description: 'Refined drapery, blinds, and treatments that add elegance and control to every room.' },
  { title: 'Furniture Selection', icon: 'ri-armchair-line', description: 'Classic and contemporary furniture chosen to match your aesthetic and lifestyle.' },
  { title: 'Furniture Customization', icon: 'ri-pencil-ruler-line', description: 'Bespoke furniture crafted to your exact specifications, materials, and dimensions.' },
  { title: 'Space Planning & Layout', icon: 'ri-layout-masonry-line', description: 'Strategic spatial planning that maximizes flow, function, and visual harmony.' },
  { title: 'Office Space Design', icon: 'ri-building-3-line', description: 'Professional workspace environments that reflect your brand with sophisticated design.' },
  { title: 'Commercial Space Design', icon: 'ri-store-line', description: 'Impressive commercial environments that elevate your business presence and client experience.' },
  { title: 'Installation Services', icon: 'ri-settings-3-line', description: 'Professional installation by experienced craftsmen with precision and care.' },
  { title: 'Procurement & Purchasing', icon: 'ri-shopping-bag-line', description: 'Full-service procurement — we handle all sourcing, coordination, and acquisition.' },
  { title: 'Home Organization', icon: 'ri-stack-line', description: 'Elegant organizational systems that bring beauty, order, and calm to your spaces.' },
  { title: 'Residential Space Design', icon: 'ri-community-line', description: 'Comprehensive residential design transforming properties into extraordinary homes.' },
];

export const SERVICE_AREAS = [
  'Beverly Hills',
  'Los Angeles',
  'West Hollywood',
  'Pacific Palisades',
  'Brentwood',
  'Century City',
  'Malibu',
  'West Los Angeles',
  'Hollywood',
  'Hollywood Hills',
  'Bel Air',
  'Santa Monica',
  'Westwood',
  'Hancock Park',
  'Encino',
  'Beverly Park',
  'Hidden Hills',
];

export const TESTIMONIALS = [
  {
    name: 'Karen Carter',
    location: 'Beverly Hills, CA',
    text: 'From bedroom to kitchen, bathroom to nursery, Lisa\'s attention to detail and creativity exceeded our expectations. Her renovation consultation was invaluable, and her expert advice on lighting, flooring, and art selection truly elevated our space.',
    initials: 'KC',
  },
  {
    name: 'Samuel Moore',
    location: 'Los Angeles, CA',
    text: 'Lisa Merkle Design is a master at creating functional and stylish spaces. We approached them for our kitchen design, and the result was breathtaking. Their keen eye for detail transformed it into the heart of our home.',
    initials: 'SM',
  },
  {
    name: 'Patrick Martinez',
    location: 'West Hollywood, CA',
    text: 'Lisa Merkle Design provided us with an exceptional renovation consultation that guided our project\'s success. They helped us navigate the complexities of our dining room and bathroom design, turning them into elegant, functional spaces.',
    initials: 'PM',
  },
  {
    name: 'Douglas Lopez',
    location: 'Bel Air, CA',
    text: 'Lisa Merkle Design made our house a haven with their bedroom and nursery design services. Their meticulous approach to every detail, from flooring selection to lighting, created serene and beautiful spaces. Lisa\'s services saved us time and money.',
    initials: 'DL',
  },
];

export const PORTFOLIO_IMAGES: { src: string; alt: string; category: string }[] = [
  {
    src: 'https://images.unsplash.com/photo-1555041469-a586c61ea9bc?w=800&h=600&q=75&auto=format&fit=crop',
    alt: 'Contemporary luxury living room',
    category: 'Living Room',
  },
  {
    src: 'https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=600&h=600&q=75&auto=format&fit=crop',
    alt: 'Luxury kitchen design',
    category: 'Kitchen',
  },
  {
    src: 'https://images.unsplash.com/photo-1540518614846-7eded433c457?w=600&h=900&q=75&auto=format&fit=crop',
    alt: 'Elegant master bedroom',
    category: 'Bedroom',
  },
  {
    src: 'https://images.unsplash.com/photo-1552321554-5fefe8c9ef14?w=800&h=600&q=75&auto=format&fit=crop',
    alt: 'Luxury spa bathroom',
    category: 'Bathroom',
  },
  {
    src: 'https://images.unsplash.com/photo-1617806118233-18e1de247200?w=600&h=600&q=75&auto=format&fit=crop',
    alt: 'Formal dining room',
    category: 'Dining Room',
  },
  {
    src: 'https://images.unsplash.com/photo-1593642632559-0c6d3fc62b89?w=600&h=900&q=75&auto=format&fit=crop',
    alt: 'Refined home office',
    category: 'Home Office',
  },
  {
    src: 'https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=800&h=600&q=75&auto=format&fit=crop',
    alt: 'Open plan luxury interior',
    category: 'Interior',
  },
  {
    src: 'https://images.unsplash.com/photo-1522771739844-6a9f6d5f14af?w=600&h=600&q=75&auto=format&fit=crop',
    alt: 'Elegant nursery design',
    category: 'Nursery',
  },
  {
    src: 'https://images.unsplash.com/photo-1568605114967-8130f3a36994?w=800&h=600&q=75&auto=format&fit=crop',
    alt: 'Beverly Hills residential exterior',
    category: 'Exterior',
  },
];
